import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const LIST_ORGANIZATIONS = gql`
  query($filter: ListCompaniesFilter, $sort: ListCompaniesSort) {
    listCompanies(filter: $filter, sort: $sort) {
      count
      data {
        createdAt
        email
        id
        isActive
        logo
        name
        slug
        url
      }
    }
  }
`;

export const GET_ORGANIZATION_DETAIL = gql`
  query($where: CompanyWhereUniqueInput!) {
    getCompany(where: $where) {
      email
      logo
      name
      slug
      url
    }
  }
`;

export const GET_ORGANIZATION_CONFIG = gql`
  query($where: GetCompanyConfigWhereInput!) {
    getCompanyConfig(where: $where) {
      id
      fonts
      formSteps {
        key
        order
      }
      themeColors
      buttons
      bookSurvey
      waitList
      layout
      updateEpcCta
      recommendationPopup
      recommendationsDefaultSort
      emailCaptureComponent {
        backgroundImage
        variant
      }
      headerComponent {
        backgroundImage
        config
        variant
      }
      formCustomization {
        key
        visibility
      }
      analytics {
        key
      }
      result {
        key
        label
        visibility
        order
      }
      recommendations {
        key
        label
        visibility
      }
      tooltip
      addToPlan
      alignment
      blogSectionEnabled
      blogComponent
    }
  }
`;

export const GET_SIGNED_URL = gql`
  query($data: GetCompanyUploadSignedUrlInput!) {
    getCompanyUploadSignedUrl(data: $data) {
      key
      signedUrl
    }
  }
`;

export const LIST_UI_LABELS = gql`
  query($where: GetUILabelsWhereInput, $filter: GetUILabelsFilter) {
    getUILabels(where: $where, filter: $filter) {
      count
      data {
        value
        type
        languageCode
        key
        id
      }
    }
  }
`;

export const GET_EMAIL_CONFIG = gql`
  query($where: GetCompanyConfigWhereInput!) {
    getCompanyConfig(where: $where) {
      emailConfig {
        apiKey
        baseUrl
        email
        name
        replyToEmail
        groupId
        templates {
          key
          id
        }
      }
      id
    }
  }
`;

export const GET_ORGANIZATION_RECOMMENDATION_FIELD_CONFIG = gql`
  query($where: GetCompanyConfigWhereInput!) {
    getCompanyConfig(where: $where) {
      id
      result {
        key
        label
        visibility
        timePeriod
        order
      }
    }
  }
`;

export const GET_ORGANIZATION_MEASURES_FIELD_CONFIG = gql`
  query($where: GetCompanyConfigWhereInput!) {
    getCompanyConfig(where: $where) {
      id
      recommendations {
        key
        label
        visibility
        timePeriod
      }
    }
  }
`;

export const GET_ORGANIZATION_MORTGAGE_LOAN_CONFIG = gql`
  query($where: GetCompanyConfigWhereInput!) {
    getCompanyConfig(where: $where) {
      id
      mortgageLoan {
        defaultValue
        key
        label
        max
        min
        step
        visibility
      }
    }
  }
`;

export const GET_ORGANIZATION_CUSTOMISATION_PANEL_CONFIG = gql`
  query CustomizationPanelConfig($where: GetCompanyConfigWhereInput!) {
    getCompanyConfig(where: $where) {
      id
      customizationPanelConfig {
        key
        label
        order
        visibility
      }
    }
  }
`;

export const GET_CONFIG_UPLOAD_SIGNED_URL = gql`
  query($input: GetCompanyConfigsUploadSignedUrlInput!) {
    getCompanyConfigsUploadSignedUrl(input: $input) {
      key
      signedUrl
    }
  }
`;

export const GET_COMPANY_CONFIG_IMAGE_UPLOAD_URL = gql`
  query GetCompanyConfigImageUploadUrl(
    $data: GetCompanyConfigImageUploadUrlInput!
  ) {
    getCompanyConfigImageUploadUrl(data: $data) {
      key
      signedUrl
    }
  }
`;

export const GET_BLOG_UPLOAD_URL = gql`
  query GetBlogAssetsUploadSignedUrl(
    $data: GetBlogAssetsUploadSignedUrlInput!
  ) {
    getBlogAssetsUploadSignedUrl(data: $data) {
      signedUrl
      key
    }
  }
`;

export const BLOGS_LIST = gql`
  query Blogs($filter: BlogsFilter!, $sort: BlogsSort) {
    blogs(filter: $filter, sort: $sort) {
      count
      data {
        id
        companyId
        link
        title
        description
        image
        icon
        order
        createdAt
        updatedAt
      }
    }
  }
`;

export const BLOG = gql`
  query Blog($where: BlogWhereUniqueInput!) {
    blog(where: $where) {
      id
      companyId
      link
      title
      description
      image
      icon
      order
      createdAt
      updatedAt
    }
  }
`;
